define('models/shared/securityquestions/securityquestion_collection',["backbone",
        "models/shared/securityquestions/securityquestion"
], function (Backbone, SecurityQuestion) {

    var SecurityQuestions = Backbone.Collection.extend({
        url: function () {
            if (this.instanceURL)
                return this.instanceURL;
            return pf.lookupsURL + "/SecurityQuestions"
        },
        model: SecurityQuestion,
        initialize: function (options) {
            options = options || {};
            this.instanceURL = options.instanceURL;
        },
       
    });
    return SecurityQuestions;
});

